// Le calendrier « Au » d'une période non travaillée s'ouvre sur le mois de « Du » (retour de Nicolas, 30/10),
// dans l'onglet agence (`agency_calendar_controller.js`) comme dans le tiroir « Réglages »
// (`plan_settings_controller.js`). Passe par la valeur `anchor` de `date_picker_controller.js` : un REPÈRE de
// mois, jamais une date choisie (un « Au » vide reste vide), ignoré dès que « Au » a sa propre date.

import { isValidIsoDate } from './planning_calendar_date_formats.js';

const DATE_PICKER_ROOT = '[data-controller~="date-picker"]';
const ANCHOR_ATTRIBUTE = 'data-date-picker-anchor-value';

/**
 * Pose (ou retire, « Du » vide ou invalide) le repère du sélecteur « Au » de la ligne.
 *
 * @param {Element|null} endField le champ ISO caché de « Au »
 * @param {string} startIso la valeur ISO de « Du »
 */
export function anchorEndOnStart(endField, startIso) {
  const picker = endField?.closest(DATE_PICKER_ROOT);
  if (!picker) return;
  const anchor = isValidIsoDate(startIso) ? startIso : '';
  // Rien à écrire : pas de mutation, donc pas de `anchorValueChanged` qui ramènerait le mois affiché.
  if ((picker.getAttribute(ANCHOR_ATTRIBUTE) ?? '') === anchor) return;
  if (anchor) picker.setAttribute(ANCHOR_ATTRIBUTE, anchor);
  else picker.removeAttribute(ANCHOR_ATTRIBUTE);
}
